import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import TwoColumn from './TwoColumn';

const schema: JSONSchema7 = {
    title: 'Two Column',
    type: 'object',
    required: [],
    properties: {
        styles: { type: 'string', default: '', description: 'A stylesheet' },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        leftColumnOptions: {
            type: 'object',
            title: 'Left Column Options',
            description: 'Inline Styles',
            properties: {
                width: { type: 'string', default: '50%' },
                padding: { type: 'string', default: '10px' },
                border: { type: 'string', default: '1px dashed lightgrey' },
            },
        },
        rightColumnOptions: {
            type: 'object',
            title: 'Right Column Options',
            description: 'Inline Styles',
            properties: {
                width: { type: 'string', default: '50%' },
                padding: { type: 'string', default: '10px' },
                border: { type: 'string', default: '1px dashed lightgrey' },
            },
        },
        isTransformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default:
                                // eslint-disable-next-line max-len
                                'return (data) => { return { renderLeftColumn, renderRightCoulmn } }',
                        },
                    },
                },
                {
                    properties: {
                        isTransformData: { enum: [false] },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['leftColumnOptions', 'rightColumnOptions'],
        'Transform Data': ['isTransformData', 'functionToTransform'],
        Accessibility: ['disableTabStaticData'],
    },
];

const TwoColumnWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToTransform: { 'ui:widget': 'JSEditor' },
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: TwoColumn,
    id: 'TwoColumn',
    group: 'layout',
    contentPlaceHolders: ['leftColumn', 'rightColumn'],
    initialData: () => ({
        styles: '',
        leftColumnOptions: {
            width: '50%',
            padding: '10px',
            border: '1px dashed lightgrey',
        },
        rightColumnOptions: {
            width: '50%',
            padding: '10px',
            border: '1px dashed lightgrey',
        },
    }),
};

export default TwoColumnWidget;
